// src/Availability.jsx
import React, { useEffect, useState } from 'react';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { PlusIcon, ClockIcon, TrashIcon } from 'lucide-react';
import { useAuth } from '../lib/AuthContext';
import AvailabilityModal from '../components/AvailabilityModal';
import { toast } from 'react-toastify';

const Availability = () => {
  const { accessToken: token } = useAuth();
  const [availabilities, setAvailabilities] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const daysOfWeek = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

  useEffect(() => {
    if (!token) return;

    fetch('https://quirkleai.com/api/availability/', {
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(res => res.json())
      .then(data => setAvailabilities(data))
      .catch(() => toast.error("Could not load availability"));
  }, [token]);

  const handleAddAvailability = ({ day_of_week, start_time, end_time }) => {
    fetch('https://quirkleai.com/api/availability/', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify({ day_of_week, start_time, end_time })
    })
      .then(res => {
        if (!res.ok) throw new Error();
        return res.json();
      })
      .then((newItem) => {
        setAvailabilities(prev => [...prev, newItem]);
        toast.success("Availability added!");
      })
      .catch(() => toast.error("Failed to add availability"))
      .finally(() => setIsModalOpen(false));
  };

  const handleDeleteAll = () => {
    if (window.confirm("Are you sure you want to delete all your availability slots?")) {
      fetch('https://quirkleai.com/api/availability/delete_all/', {
        method: 'DELETE',
        headers: { Authorization: `Bearer ${token}` },
      })
        .then(res => {
          if (!res.ok) {
            throw new Error("Failed to delete all availabilities");
          }
          setAvailabilities([]); // Clear the state on success
          toast.success("All availability has been deleted.");
        })
        .catch(err => {
          toast.error(err.message);
        });
    }
  };
console.log("Availability type:", typeof availabilities);
console.log("Availability value:", availabilities);
console.log("Availability length:", availabilities.length);
  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h2 className="text-2xl font-semibold text-gray-900">Your Recurring Availability</h2>
        <div className="flex items-center gap-2">
          
          <Button onClick={() => setIsModalOpen(true)}>
            <PlusIcon size={16} className="mr-2" />
            Add Recurring Availability
          </Button>
          {availabilities.length > 0 && (
            <Button variant="default" onClick={handleDeleteAll}>
              <TrashIcon size={16} className="mr-2" />
              Delete All
            </Button>
          )}
        </div>
      </div>

      {availabilities.length === 0 && (
        <p className="text-sm text-gray-500">You have not set any recurring availability yet.</p>
      )}

      <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-4">
        {availabilities.map((slot) => (
          <Card key={slot.id} className="bg-white border shadow-sm rounded-lg">
            <CardContent className="p-4 space-y-2">
              <div className="flex justify-between items-center">
                <div className="text-sm text-gray-700 flex items-center gap-2">
                  <ClockIcon size={14} />
                  {daysOfWeek[slot.day_of_week]}: {slot.start_time} - {slot.end_time}
                </div>
                <Button size="sm" variant="destructive" onClick={() => handleDelete(slot.id)}>
                  <TrashIcon size={14} />
                </Button>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>

      <AvailabilityModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onSubmit={handleAddAvailability}
      />
    </div>

    
  );
};

export default Availability;